import { Stack } from "@mantine/core"
import { SignalIndicator, Tooltip } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { AgecComplianceStepTooltipLabel } from "~/pages/Brand/Regulations/AGEC/AgecComplianceStepTooltipLabel.tsx"
import { NonEligibleProductTooltip } from "~/pages/Brand/Regulations/AGEC/NonEligibleProductTooltip.tsx"
import { isDefined } from "~/utils/types"

export type AgecComplianceStepCellProps = {
  readonly step: number | null | undefined
}

/**
 * AGEC compliance column: signal bars for applicable products, grey check when not applicable,
 * and a tooltip with a vertical Mantine stepper explaining step 1 / step 2 status.
 */
export const AgecComplianceStepCell = ({
  step,
}: AgecComplianceStepCellProps) => {
  const { t } = useTranslation("products")

  if (!isDefined(step)) {
    return <NonEligibleProductTooltip />
  }

  const ariaLabel: string =
    step === 2
      ? t("lists.cells.agec.step2")
      : step === 1
        ? t("lists.cells.agec.step1")
        : t("lists.cells.agec.nonCompliant")

  return (
    <Tooltip
      label={<AgecComplianceStepTooltipLabel step={step} />}
      withArrow
      openDelay={250}
      maw={420}
      styles={{
        tooltip: {
          backgroundColor: "var(--mantine-color-body)",
          color: "var(--mantine-color-text)",
          border: "1px solid var(--mantine-color-gray-4)",
          borderRadius: "var(--mantine-radius-lg)",
          padding: "var(--mantine-spacing-md)",
        },
        arrow: {
          backgroundColor: "var(--mantine-color-body)",
        },
      }}
    >
      <Stack px="sm" style={{ width: "fit-content" }}>
        <SignalIndicator
          level={step}
          maxLevel={2}
          ariaLabel={ariaLabel}
          size="sm"
        />
      </Stack>
    </Tooltip>
  )
}
